// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert[data-v-78e33290] .v-icon{align-self:center}.alert__msg[data-v-78e33290]{font-size:.8rem;max-width:500px;display:-webkit-box;line-clamp:3;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;max-height:60px}", ""]);
// Exports
module.exports = exports;
